import { bootstrapApplication } from '@angular/platform-browser';

import './polyfills';
import { App } from './app/app';
import { appConfig } from './app/app.config';

void bootstrapApplication(App, appConfig);
